

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const PERFORMANCE_API_URL = 'analysis/performance-data/';
const PERFORMANCE_DRR_TABLE_URL = 'trust/case-detail/';


export const fetchPerformance = createAsyncThunk(
    'performance/fetchPerformance',
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
         
            const query = state.filters.query;

            if (!token) {
                return;
            }
            const { selectedCategory, team_member, team_leader } = params;
            const queryParams = {};


            // Add selected trust IDs
            if (Array.isArray(query?.trust_id) && query?.trust_id.length !== 0) {
                queryParams.portfolio_id = query?.trust_id?.join(',');
            }
            if (Array.isArray(query?.state) && query.state.length !== 0) {
                queryParams.state = query.state.join(',');
            }
            if (Array.isArray(query?.region) && query.region.length !== 0) {
                queryParams.region = query.region.join(',');
            }
            if (Array.isArray(query?.status) && query.status.length !== 0) {
                queryParams.status = query.status.join(',');
            }
            if (Array.isArray(query?.date_to) && query.date_to.length !== 0) {
                queryParams.date_to = query.date_to.join(',');
            }
            if (Array.isArray(query?.date_from) && query.date_from.length !== 0) {
                queryParams.date_from = query.date_from.join(',');
            }
            if (Array.isArray(query?.agency) && query.agency.length !== 0) {
                queryParams.agency = query.agency.join(',');
            }
            if (Array.isArray(query?.loan_type
            ) && query.loan_type
                .length !== 0) {
                queryParams.loan_type
                    = query.loan_type
                        .join(',');
            }

            if (Array.isArray(query?.team_member) && query.team_member.length !== 0) {
                queryParams.team_member = query.team_member.join(',');
            }
            if (Array.isArray(query?.team_leader) && query.team_leader.length !== 0) {
                queryParams.team_leader = query.team_leader.join(',');
            }
            if (selectedCategory !== null && selectedCategory !== undefined && team_leader?.length === 0 && team_member?.length === 0) {    

                queryParams.entity_type = selectedCategory;
            }

              if (Array.isArray(team_member) && team_member.length !== 0) {
                queryParams.team_member = team_member.join(',');
            }
            if (Array.isArray(team_leader) && team_leader.length !== 0) {
                queryParams.team_leader = team_leader.join(',');
            }
            


            const response = await axios.get(PERFORMANCE_API_URL, {
                params: queryParams,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch analysis'
            );
        }
    }
);

export const fetchDRRTable = createAsyncThunk(
    'performance/fetchdrrTable',
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
         
            const query = state.filters.query;

            if (!token) {
                return;
            }
            const { selectedCategory, team_member, team_leader, page_size ,page } = params;
            const queryParams = { ...query };


            // Add selected trust IDs
            if (Array.isArray(query?.trust_id) && query?.trust_id.length !== 0) {
                queryParams.trust_id = query?.trust_id?.join(',');
            }
            if (Array.isArray(query?.state) && query.state.length !== 0) {
                queryParams.state = query.state.join(',');
            }
            if (Array.isArray(query?.region) && query.region.length !== 0) {
                queryParams.region = query.region.join(',');
            }
            if (Array.isArray(query?.status) && query.status.length !== 0) {
                queryParams.status = query.status.join(',');
            }
            if (Array.isArray(query?.date_to) && query.date_to.length !== 0) {
                queryParams.date_to = query.date_to.join(',');
            }
            if (Array.isArray(query?.date_from) && query.date_from.length !== 0) {
                queryParams.date_from = query.date_from.join(',');
            }
            if (Array.isArray(query?.agency) && query.agency.length !== 0) {
                queryParams.agency = query.agency.join(',');
            }
            if (Array.isArray(query?.loan_type
            ) && query.loan_type
                .length !== 0) {
                queryParams.loan_type
                    = query.loan_type
                        .join(',');
            }

            if (Array.isArray(query?.team_member) && query.team_member.length !== 0) {
                queryParams.team_member = query.team_member.join(',');
            }
            if (Array.isArray(query?.team_leader) && query.team_leader.length !== 0) {
                queryParams.team_leader = query.team_leader.join(',');
            }
            // if (selectedCategory !== null && selectedCategory !== undefined && team_leader?.length === 0 && team_member?.length === 0) {    

            //     queryParams.entity_type = selectedCategory;
            // }

              if (Array.isArray(team_member) && team_member.length !== 0) {
                queryParams.team_member = team_member.join(',');
            }
            if (Array.isArray(team_leader) && team_leader.length !== 0) {
                queryParams.team_leader = team_leader.join(',');
            }

            if (page !== null && page !== undefined ) {    
                queryParams.page = page;
            }
            if (page_size !== null && page_size !== undefined ) {    
                queryParams.page_size = page_size;
            }
            


            const response = await axios.get(PERFORMANCE_DRR_TABLE_URL, {
                params: queryParams,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch analysis'
            );
        }
    }
);



// --------------------------- end thunk ---------------
const initialState = {
    performance: [],
    loading: false,
    error: null,
    drr_table:[],
    drr_loading: false,
    drr_error: null,

};

const performanceSlice = createSlice({
    name: 'performance',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPerformance.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPerformance.fulfilled, (state, action) => {
                state.loading = false;
                state.performance = action.payload;
            })

            .addCase(fetchPerformance.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Something went wrong';
                state.drr_table = []
                state.error = null
            })

            .addCase(fetchDRRTable.pending, (state) => {
                state.drr_loading = true;
                state.drr_error = null;
            })
            .addCase(fetchDRRTable.fulfilled, (state, action) => {
                state.drr_loading = false;
                state.drr_table = action.payload;
            })

            .addCase(fetchDRRTable.rejected, (state, action) => {
                state.drr_loading = false;
                state.drr_error = action.payload || 'Something went wrong';
                state.drr_table = []
                
            })
    },
});


export default performanceSlice.reducer;
